var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 5.72C16.94 2.09 13.56 0 10 0C8.22 0 6.49 0.52 4.91 1.49C3.33 2.47 1.91 3.9 0.75 5.72C-0.25 7.29 -0.25 9.84 0.75 11.41C3.06 15.05 6.44 17.13 10 17.13C11.78 17.13 13.51 16.61 15.09 15.64C16.67 14.66 18.09 13.23 19.25 11.41C20.25 9.85 20.25 7.29 19.25 5.72ZM10 12.61C7.76 12.61 5.96 10.8 5.96 8.57C5.96 6.34 7.76 4.53 10 4.53C12.24 4.53 14.04 6.34 14.04 8.57C14.04 10.8 12.24 12.61 10 12.61Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.09bf69457149d48c986b2a3c91498298.svg";
export { ForwardRef as ReactComponent };